import React, { useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import ServiceBasicInformation from './NewServiceForms/ServiceBasicInformation';
import ServiceHeader from './NewServiceForms/ServiceHeader';
import ServiceUpload from './NewServiceForms/ServiceUpload';
import ServiceDetails from './NewServiceForms/ServiceDetails';
import axios from 'axios';
import { createService } from 'lib/apiService';
import ServiceTag from './NewServiceForms/ServiceTag';

const schema = yup
  .object({
    title: yup.string().required('Энэ талбарыг оруулна уу!'),
    description: yup.string().required('Энэ талбарыг оруулна уу!'),
    tags: yup.array().required('Энэ талбарыг оруулна уу!')
  })
  .required();

const ServiceAdd = () => {
  const navigage = useNavigate();
  const submittedValues = {};
  const methods = useForm({
    resolver: yupResolver(schema)
  });
  const [loading, setLoading] = useState(false);
  const { handleSubmit, reset } = methods;
  const [files, setFiles] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

  const imageUploader = async image => {
    setLoading(true);

    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'eruulmend'); // Replace with your upload preset

    const res = await fetch(
      'https://api.cloudinary.com/v1_1/dvhdmr8yi/image/upload',
      {
        method: 'POST',
        body: formData
      }
    );

    const data = await res.json();
    setImageUrls(prevUrls => [
      ...prevUrls,
      {
        url: data.secure_url,
        public_id: data.public_id,
        name: data.display_name
      }
    ]);

    setLoading(false);
  };

  const onSubmit = data => {
    if (Object.keys(data).length === 0) {
      toast.warning('Та мэдээллээ гүйцэт оруулна уу', {
        theme: 'colored'
      });
    } else {
      const tags = data.tags.map(item => item.value);
      data.image = imageUrls;
      data.tags = tags;
      createService(data)
        .then(result => {
          if (result.data.success) {
            toast.success(`Амжиллтай үүсгэгдлээ`, {
              theme: 'colored'
            });

            const keys = Object.keys(data);
            for (const key of keys) {
              if (
                key !== 'conditions' ||
                key !== 'requirements' ||
                key !== 'advantages'
              ) {
                submittedValues[key] = '';
              } else {
                submittedValues[key] = [];
              }
            }
            reset();
            navigage(`/blog/blog-update/${result?.data?.data?._id}`);
          }
        })
        .catch(error => {
          toast.warning(`${error.response.data.error.message}`, {
            theme: 'colored'
          });
        });
    }
  };

  const handleRemove = path => {
    let removeItem = '';
    imageUrls.forEach(item => {
      if (item.bucketname === path) {
        removeItem = item.public_id;
      }
    });
    setFiles(files.filter(file => file.path !== path));
    const updatedImageUrls = imageUrls.filter(
      image => image.bucketname !== path
    );
    setImageUrls(updatedImageUrls);
    if (removeItem) {
      axios
        .post(`https://admin.gegeensoft.live/api/v1/images/removeimage`, {
          public_id: removeItem
        })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          console.log('CLOUDINARY UPLOAD FAILED', error);
        });
    }
  };

  return (
    <FormProvider {...methods}>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row className="g-3">
          <Col xs={12}>
            <ServiceHeader />
          </Col>
          <Col lg={8}>
            <ServiceBasicInformation />

            <ServiceUpload
              setFiles={setFiles}
              files={files}
              imageUploader={imageUploader}
              handleRemove={handleRemove}
              loading={loading}
            />
            <ServiceDetails />
          </Col>
          <Col lg={4}>
            <div className="sticky-sidebar">
              <ServiceTag />
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
  );
};

export default ServiceAdd;
